<template>
  <PflegeBaseComponentTemplate
    v-editable="props.blok"
    :actions-alignment="props.blok.actionsAlignment"
    :background-color="getPflegeColorName(props.blok.backgroundColor.value)"
    :data-uid="props.blok._uid"
    :heading="props.blok.heading"
    :heading-tag="props.blok.headingTag"
    :subline="props.blok.subline"
    :subline-tag="props.blok.sublineTag"
    :text-align="props.blok.textAlign"
    :heading-class="props.blok.headingClass"
    :subline-class="props.blok.sublineClass"
  >
    <template v-if="props.blok.media" #media>
      <WPElementMedia
        v-for="asset in props.blok.media"
        :key="asset._uid"
        :blok="asset"
        :aspect-ratio="aspectRatios.m"
      />
    </template>

    <template v-if="willRender(props.blok.content!)" #default>
      <RichtextResolver :blok="props.blok.content!" />
    </template>

    <template v-if="props.blok.actions" #actions>
      <WPElementButton v-for="button in props.blok.actions" :key="button._uid" :blok="button" />
    </template>
  </PflegeBaseComponentTemplate>
</template>

<script lang="ts" setup>
import { PflegeBaseComponentTemplate } from '@webcarelbj/shared-components'
import { BlokBaseComponentTemplate, BlokProps } from '../../types/blok'
import { RichtextResolver, WPElementMedia, WPElementButton } from '../'
import type { ButtonBlok, WPElementMediaBlok } from '../'
import { willRender, aspectRatios, getPflegeColorName } from '../../utils'
import { DocContent } from '../../types/richtext'

export interface CardComponentBlok extends BlokBaseComponentTemplate {
  headingTag?: '' | 'h2' | 'h3' | 'h1'
  headingClass?: '' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  subline?: string
  sublineTag?: '' | 'h3' | 'h4' | 'h5' | 'h6'
  sublineClass?: '' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  actions?: ButtonBlok[]
  content?: DocContent
  media?: WPElementMediaBlok[]
}

const props = defineProps<BlokProps<CardComponentBlok>>()
</script>
